import { useState } from 'react';
import { Link } from 'react-router-dom';
import { mangaList } from '@/mocks/manga';
import MangaCard from '@/components/feature/MangaCard';

function StatusSection() {
  const [tab, setTab] = useState<'finished' | 'serializing'>('finished');
  const items = mangaList.filter((m) => m.status === tab).slice(0, 8);

  return (
    <section className="mx-auto w-full max-w-7xl px-4 py-12 md:px-6 md:py-16" aria-labelledby="status-title">
      <div className="mb-8 flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
        <div>
          <span className="text-xs font-bold uppercase tracking-widest text-secondary-700">状态分类</span>
          <h2 id="status-title" className="mt-1 font-heading text-2xl font-bold text-foreground-950 md:text-3xl">
            完结漫画与连载中漫画
          </h2>
          <p className="mt-2 text-sm text-foreground-600">按更新状态分门别类，追更更轻松</p>
        </div>
        <div className="flex rounded-full bg-background-100 p-1" role="tablist" aria-label="漫画状态切换">
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'finished'}
            onClick={() => setTab('finished')}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-5 py-2 text-sm font-bold transition-colors ${
              tab === 'finished' ? 'bg-secondary-500 text-background-50' : 'text-foreground-700 hover:text-secondary-600'
            }`}
          >
            <i className="ri-checkbox-circle-fill"></i> 完结漫画
          </button>
          <button
            type="button"
            role="tab"
            aria-selected={tab === 'serializing'}
            onClick={() => setTab('serializing')}
            className={`flex items-center gap-1.5 whitespace-nowrap rounded-full px-5 py-2 text-sm font-bold transition-colors ${
              tab === 'serializing' ? 'bg-primary-500 text-background-50' : 'text-foreground-700 hover:text-primary-600'
            }`}
          >
            <i className="ri-flashlight-fill"></i> 连载中
          </button>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4 sm:grid-cols-3 md:grid-cols-4 md:gap-5">
        {items.map((item) => (
          <MangaCard key={item.slug} item={item} />
        ))}
      </div>

      <div className="mt-8 text-center">
        <Link
          to={`/category?status=${tab}`}
          className="inline-flex items-center justify-center whitespace-nowrap rounded-md border border-background-300 bg-background-100 px-6 py-2.5 text-sm font-bold text-foreground-800 transition-colors hover:border-primary-300 hover:text-primary-600"
        >
          查看更多{tab === 'finished' ? '完结' : '连载中'}漫画
          <i className="ri-arrow-right-line ml-1.5"></i>
        </Link>
      </div>
    </section>
  );
}

export default StatusSection;